// extracted by mini-css-extract-plugin
export default {"header":"trips-collaboration-ShareTripPopup__header--2IYWs","strong":"trips-collaboration-ShareTripPopup__strong--1W5pM"};